import React from "react";
import { useFormik } from "formik";
// import { z } from 'zod';
// import { useStore } from 'zustand';
import {
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  Box,
  Stack,
  Divider,
  FormControl,
  InputLabel,
} from "@mui/material";
import { TableFilterProps } from "src/models/filter";
import { LoadingButton } from "@mui/lab";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { useAppZStore } from "src/store/zStore";
import { removeNullAttributes } from "src/utils/objectHelper";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";

dayjs.extend(utc);

const TableFilter: React.FC<TableFilterProps> = ({
  config,
  tableName,
  schema,
}) => {
  const closeDrawer = useAppZStore((state) => state.closeDrawer);
  const setFilters = useAppZStore((state) => state.setFilters);
  const filters = useAppZStore((state) => state.filters[tableName]);

  const initialValues: any = filters ?? {};

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      setFilters({ [tableName]: removeNullAttributes(values) });
      closeDrawer();
    },
  });

  const clearFilters = () => {
    Object.keys(formik.values).forEach((key) => {
      formik.setFieldValue(key, "");
    });
    setFilters({ [tableName]: {} });
    closeDrawer();
  };

  return (
    <Box m={2}>
      <Typography variant="h2">{tableName} Filter</Typography>
      <Divider sx={{ m: 2 }} />
      <Box my={2}>
        <form onSubmit={formik.handleSubmit}>
          {config.map((field, index) => (
            <Box key={field.label} my={2}>
              {field.type === "date" && (
                <DateTimePicker
                  label={field.label}
                  sx={{ width: "100%" }}
                  timezone="UTC"
                  format="DD/MM/YYYY hh:mm:ss"
                  onChange={(value) =>
                    formik.setFieldValue(field.id, value, true)
                  }
                  value={formik.values[field.id]}
                />
              )}

              {field.type === "text" && (
                <>
                  <TextField
                    fullWidth
                    id={field.id}
                    label={field.label}
                    name={field.id}
                    variant="outlined"
                    onChange={formik.handleChange}
                    value={formik.values[field.id] ?? ""}
                    helperText={field.helperText}
                  />
                  {formik.errors[field.id] && formik.touched[field.id] && (
                    <Typography color="error">
                      {`${formik.errors[field.id]}`}
                    </Typography>
                  )}
                </>
              )}

              {field.type === "dropdown" && (
                <FormControl fullWidth>
                  <InputLabel id={field.id}>{field.label}</InputLabel>
                  <Select
                    labelId={field.id}
                    id={field.id}
                    label={field.label}
                    name={field.id}
                    onChange={formik.handleChange}
                    value={formik.values[field.id] ?? ""}
                  >
                    <MenuItem value={""}>--</MenuItem>
                    {config[index].options?.map((option) => (
                      <MenuItem
                        key={`${tableName}-${index}-${option.value}`}
                        value={option.value}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Box>
          ))}
          <Stack direction="row" spacing={1} alignItems="center" sx={{ my: 2 }}>
            <LoadingButton
              fullWidth
              onClick={() => clearFilters()}
              variant="outlined"
            >
              Clear
            </LoadingButton>
            <LoadingButton fullWidth type="submit" variant="contained">
              Submit
            </LoadingButton>
          </Stack>
        </form>
      </Box>
    </Box>
  );
};

export default TableFilter;
